import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareArrowTopRight2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="square-arrow-top-right-2, open, new, link, open link, box, arrow"><path d="M9.25 3.75H3.75V20.25H20.25V14.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M13.75 3.75H20.25V10.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M19.7451 4.25488L11 13" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconSquareArrowTopRight2;
